class ChatClient {
  constructor(authToken) {
    this.authToken = authToken;
    this.ws = null;
    this.subscriptions = new Map();
    this.onMessage = null;
    this.onTyping = null;
    this.onConnected = null;
    this._reconnectTimer = null;
    this._pingInterval = null;
    this._destroyed = false;
  }

  connect() {
    if (this._destroyed) return;
    this._cleanup();

    this.ws = new WebSocket('wss://rchat.uniapp.vn/websocket');

    this.ws.onopen = () => {
      this.ws.send(
        JSON.stringify({ msg: 'connect', version: '1', support: ['1'] })
      );
    };

    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      this._handleMessage(data);
    };

    this.ws.onerror = () => {};

    this.ws.onclose = () => {
      if (!this._destroyed) {
        this._reconnectTimer = setTimeout(() => this.connect(), 3000);
      }
    };
  }

  subscribeRoom(roomId) {
    if (this.subscriptions.has(roomId)) return;
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;

    this.ws.send(
      JSON.stringify({
        msg: 'sub',
        id: `msg-${roomId}`,
        name: 'stream-room-messages',
        params: [roomId, false],
      })
    );
    this.ws.send(
      JSON.stringify({
        msg: 'sub',
        id: `typing-${roomId}`,
        name: 'stream-notify-room',
        params: [`${roomId}/typing`, false],
      })
    );

    this.subscriptions.set(roomId, true);
  }

  sendTyping(roomId, username, isTyping) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    this.ws.send(
      JSON.stringify({
        msg: 'method',
        method: 'stream-notify-room',
        id: `t-${Date.now()}`,
        params: [`${roomId}/typing`, username, isTyping],
      })
    );
  }

  disconnect() {
    this._destroyed = true;
    this._cleanup();
    this.ws?.close();
    this.ws = null;
    this.subscriptions.clear();
  }

  _cleanup() {
    if (this._reconnectTimer) {
      clearTimeout(this._reconnectTimer);
      this._reconnectTimer = null;
    }
    if (this._pingInterval) {
      clearInterval(this._pingInterval);
      this._pingInterval = null;
    }
  }

  _handleMessage(data) {
    switch (data.msg) {
      case 'ping':
        this.ws.send(JSON.stringify({ msg: 'pong' }));
        break;
      case 'connected':
        this.ws.send(
          JSON.stringify({
            msg: 'method',
            method: 'login',
            id: 'login-1',
            params: [{ resume: this.authToken }],
          })
        );
        break;
      case 'result':
        if (data.id === 'login-1' && !data.error) {
          this.onConnected?.();
        }
        break;
      case 'changed':
        if (data.collection === 'stream-room-messages') {
          const msg = data.fields?.args?.[0];
          if (msg) this.onMessage?.(msg.rid, msg);
        }
        if (data.collection === 'stream-notify-room') {
          const args = data.fields?.args;
          if (args) {
            const [username, isTyping] = args;
            const roomId = data.fields.eventName?.split('/')[0];
            this.onTyping?.(roomId, username, isTyping);
          }
        }
        break;
      default:
        break;
    }
  }
}

export default ChatClient;
